module.exports = __webpack_public_path__ + "static/media/bg-banner.aacb698a.jpeg";